import React, { useState } from 'react';
import { Button, InputField, Loader, Modal } from '../../../../Components/uielements';
import {
  ModalButtonWrapper,
  ModalWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { addDocumunet } from '../../../../services/bioplus-services/library';
import { ModalLabel } from '../../UserV2/user.style';
import { ErrorSvg, UploadIcon } from '../../../../Components/icons';
import { FileInputWrapper } from '../library.style';
import { useQueryClient } from 'react-query';

const DocumentUpload = ({ onClose, companyId }) => {
  const [error, setError] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [base64File, setBase64File] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const queryClient = useQueryClient();

  const handleFileChange = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      setBase64File(reader.result.split(',')[1]); // Extract the Base64 part
    };
    reader.onerror = () => {
      setError('Failed to process the file. Please try again.');
    };
    reader.readAsDataURL(file);
  };

  const handleUpload = async () => {
    if (!base64File || !inputValue) {
      setError('Please provide a document name and upload a valid file.');
      return;
    }
    setIsUploading(true);
    const value = {
      name: inputValue,
      base64String: base64File,
      contentType: 'application/pdf',
    };

    try {
      const res = await addDocumunet(companyId, value);
      if (res) {
        await queryClient.invalidateQueries('listOfDocs');
        setIsUploading(false);
        setUploadSuccess(true);
      }
    } catch (e) {
      setIsUploading(false);
      setError('Unable to upload the document. Please try again later.');
    }
  };

  return (
    <Modal isOpen={true} onClose={onClose} title="Upload Document">
      {!error ? (
        <ModalWrapper>
          {!uploadSuccess ? (
            <>
              <InputField
                Name="Document Name *"
                placeholder="Enter document name"
                onChange={(e) => setInputValue(e.target.value)}
              />

              {/* {inputValue && ( */}
              <FileInputWrapper>
                <label
                  htmlFor="file-upload"
                  style={{ display: 'flex', gap: '5px', placeItems: 'center' }}
                >
                  <UploadIcon />
                  Upload
                </label>
                <input
                  id="file-upload"
                  type="file"
                  accept=".pdf"
                  onChange={(e) => handleFileChange(e.target.files[0])}
                />
                <span>Only PDF files are supported</span>
              </FileInputWrapper>
              {/* )} */}

              <ModalButtonWrapper>
                {isUploading ? (
                  <Loader size="medium" loadingText="Uploading..." />
                ) : (
                  <>
                    <Button
                      varient="normal"
                      onClick={handleUpload}
                      disabled={!inputValue || !base64File}
                    >
                      Upload Doc
                    </Button>
                    <Button varient="normal" onClick={onClose}>
                      Close
                    </Button>
                  </>
                )}
              </ModalButtonWrapper>
            </>
          ) : (
            <>
              <ModalLabel>Document uploaded successfully!</ModalLabel>{' '}
              <ModalButtonWrapper>
                <Button varient="normal" onClick={onClose}>
                  Close
                </Button>
              </ModalButtonWrapper>
            </>
          )}
        </ModalWrapper>
      ) : (
        <ModalWrapper>
          <>
            <ErrorSvg
              style={{ width: '60px', height: '60px', justifySelf: 'center', paddingTop: '20px' }}
            />
            <ModalLabel>{error}</ModalLabel>
          </>
          <ModalButtonWrapper>
            <Button varient="normal" onClick={onClose}>
              Close
            </Button>
          </ModalButtonWrapper>
        </ModalWrapper>
      )}
    </Modal>
  );
};

export default DocumentUpload;
